export enum Sizes {
  ExtraLarge = 'extra-large',
  Large = 'large',
  Medium = 'medium',
  Small = 'small',
  ExtraSmall = 'extra-small',
}

export enum Variants {
  Contained = 'contained',
  Outlined = 'outlined',
}

export enum Colors {
  Inherit = 'inherit',
  Default = 'default',
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
}
